export default __webpack_public_path__ + "static/cellfina-2-ddc48769bbacb9cd77d1a7d732a896f0.jpg";